
















import Vue from 'vue';
import { mapState } from 'vuex';
import { BookingDataInterface } from '@/types/store/landing/booking/bookingDataInterface';
import { RatePlanInterface, RoomDataInterface } from '@/types/store/landing/hotels/roomDataInterface';
import { BookingDetailsInterface } from '@/types/store/landing/booking/bookingDetailsInterface';

export default Vue.extend({
  name: 'BookingPriceDetails',
  computed: {
    ...mapState({
      booking: (state: any): BookingDataInterface => state.landing.booking.data,
      roomType: (state: any): RoomDataInterface => state.landing.hotel.room,
      bookingDetails: (state: any): BookingDetailsInterface => state.landing.booking.bookingDetails,
    }),
    // eslint-disable-next-line vue/return-in-computed-property
    ratePlan(): RatePlanInterface | undefined {
      type DiscountInterface = {
        amount?: number;
        discount_amount?: number;
        amount_with_discount?: number;
        total_amount?: number;
      };
      type BookingComparedInterface = BookingDataInterface & DiscountInterface;
      let discountAmount: DiscountInterface = {};
      if (
        this.booking &&
        (this.booking as BookingComparedInterface).discount_amount &&
        this.$route.name === 'payment-success'
      ) {
        discountAmount = {
          amount:
            (this.booking as BookingComparedInterface).total_amount! +
            (this.booking as BookingComparedInterface).discount_amount!,
          discount_amount: (this.booking as BookingComparedInterface).discount_amount,
          amount_with_discount: (this.booking as BookingComparedInterface).total_amount,
        };
      }
      const plan: RatePlanInterface[] = this.filterRatePlan(
        this.roomType.rate_plans,
        this.booking.meal_option,
        this.bookingDetails.payment_method,
      );
      if (plan.length) {
        return {
          ...plan[0],
          ...discountAmount,
        };
      }
      return undefined;
    },
    withoutDiscount(): number {
      return this.ratePlan && this.ratePlan.amount ? this.ratePlan.amount : 0;
    },
    discount(): number {
      return this.ratePlan && this.ratePlan.discount_amount ? this.ratePlan.discount_amount : 0;
    },
    withDiscount(): number {
      return this.ratePlan && this.ratePlan.amount_with_discount ? this.ratePlan.amount_with_discount : 0;
    },
    couponAmount(): number {
      return !!this.ratePlan && !!this.ratePlan.discount_details ? this.ratePlan.discount_details.coupons_value : 0;
    },
  },
});
